import { X } from "lucide-react";

/**
 * Something the attorney added to a field that holds several, with the way to
 * take it back out: an inventor on a new draft.
 *
 * Not a `StatusPill`: a pill says how something is doing and cannot be removed;
 * a chip says nothing about state and is only ever removed. The remove is
 * named after what it removes, so a list of them reads as a list of acts.
 */
export function Chip({
  children,
  onRemove,
}: {
  /** What was added, which its remove is named after. */
  children: string;
  onRemove: () => void;
}) {
  return (
    <span className="inline-flex h-7 max-w-full items-center gap-1 rounded-full border border-primary/15 bg-primary/[0.06] pr-1 pl-3 text-[12.5px] font-semibold text-primary">
      <span className="truncate">{children}</span>
      <button
        type="button"
        aria-label={`Remove ${children}`}
        onClick={onRemove}
        className="inline-flex size-5 flex-none items-center justify-center rounded-full text-primary/70 transition-colors hover:bg-primary/10 hover:text-primary focus-visible:ring-2 focus-visible:ring-ring/50 focus-visible:outline-none"
      >
        <X aria-hidden className="size-3" />
      </button>
    </span>
  );
}
